/**
 * persistentAbilityZonePhase — Tick champion ground zones (Veigar E / Caitlyn W).
 */

import { tickVeigarEventHorizon } from '../../../domain/champions/veigar.js';
import { tickCaitlynYordleTrap } from '../../../domain/champions/caitlyn.js';

function tickCasterZones(caster, entities, dt) {
  if (!caster || caster.isDead) return;
  if (caster.eventHorizon) tickVeigarEventHorizon(caster, entities, dt);
  if (caster.yordleTrap) tickCaitlynYordleTrap(caster, entities, dt);
}

export function updatePersistentAbilityZones({
  championEntity,
  secondaries = [],
  allDamageableTargets = [],
  dt = 0
} = {}) {
  const entities = allDamageableTargets || [];
  tickCasterZones(championEntity, entities, dt);
  for (const secondary of secondaries) {
    tickCasterZones(secondary, entities, dt);
  }
}
